module.exports = require('./dist/pure.js');
